import React, { useState } from 'react';
import { ArrowRight, Shield, Zap, Users, CreditCard, Smartphone, Clock, CheckCircle, Star, Menu, X, ChevronDown } from 'lucide-react';

export default function CardLanding() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    if (!formData.fullName || !formData.email || !formData.message) {
      alert('Please fill in all required fields.');
      return;
    }
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      fullName: '',
      phoneNumber: '',
      email: '',
      companyName: '',
      message: ''
    });
    alert('Thank you for your inquiry! We\'ll get back to you soon.');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
             <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
               <div className="flex justify-between items-center h-16">
                 <div className="flex items-center">
                   <div className="flex items-center space-x-2">
                     <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                       <span className="text-white font-bold text-sm">A</span>
                     </div>
                     <span className="text-xl font-bold text-gray-900">AnviTech Solutions</span>
                   </div>
                 </div>
                 
                 <div className="hidden md:block">
                   <div className="ml-10 flex items-baseline space-x-8">
                     <div className="relative group">
                       <button className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium flex items-center">
                         PRODUCTS <ChevronDown className="ml-1 h-4 w-4" />
                       </button>
                     </div>
                     <div className="relative group">
                       <button className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium flex items-center">
                         SERVICES <ChevronDown className="ml-1 h-4 w-4" />
                       </button>
                     </div>
                     <div className="relative group">
                       <button className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium flex items-center">
                         ABOUT <ChevronDown className="ml-1 h-4 w-4" />
                       </button>
                     </div>
                   </div>
                 </div>
     
                 <div className="flex items-center space-x-4">
                   <button className="bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-blue-700 transition-colors">
                     LOGIN
                   </button>
                   <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                     {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                   </button>
                 </div>
               </div>
             </nav>
           </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                  Business Payments with{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                    @OMNI UPI
                  </span>
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Explore UPI for Your Business Payment Needs Like Petty Cash, Retail 
                  Expenses, Administrative Expenses And Lots More
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="px-8 py-4 bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 hover:shadow-xl transition-all transform hover:scale-105">
                  Sign up for UPI for business
                </button>
                <button className="px-8 py-4 border border-gray-300 text-gray-700 rounded-full font-semibold hover:bg-gray-50 transition-colors">
                  Book a Demo
                </button>
              </div>
            </div>
            
            <div className="relative">
              <div className="bg-gradient-to-br from-blue-100 to-purple-100 rounded-3xl p-8 transform rotate-3 hover:rotate-1 transition-transform">
                <div className="bg-white rounded-2xl p-6 shadow-xl transform -rotate-6 hover:-rotate-3 transition-transform">
                  <div className="text-center space-y-4">
                    <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mx-auto flex items-center justify-center">
                      <CreditCard className="w-8 h-8 text-white" />
                    </div>
                    <h3 className="text-lg font-semibold">OMNI UPI</h3>
                    <p className="text-sm text-gray-600">Seamless Business Payments</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Upgrade to @OMNI UPI for seamless & efficient Business Payments
            </h2>
            <p className="text-gray-600">Bring Onboard easy to use modes of payments for effortless spending</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: <Users className="w-8 h-8" />, title: "Retail Subscriptions", desc: "Easy management" },
              { icon: <Smartphone className="w-8 h-8" />, title: "Online Payments", desc: "Seamless transactions" },
              { icon: <Shield className="w-8 h-8" />, title: "Admin", desc: "Full control" },
              { icon: <CreditCard className="w-8 h-8" />, title: "Office Expenses", desc: "Track & manage" }
            ].map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2">
                <div className="text-blue-600 mb-4">{feature.icon}</div>
                <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Convenience Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Truly Convenient Payments
              </h3>
              <div className="space-y-4">
                {[
                  "Create UPI ID in 1 Click",
                  "Send & Receive Payments",
                  "UPI Powered RuPay Cards",
                  "Easy to Use Mobile App"
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Use UPI without Bank A/c
              </h3>
              <div className="space-y-4">
                {[
                  "Ensure Complete Security",
                  "Separate Business & Personal Expenses",
                  "Real Time Tracking",
                  "Powerful Dashboard for 100% Visibility"
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightning Fast Payments */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="space-y-6">
            <h2 className="text-4xl font-bold text-gray-900">
              Lightning-Fast Payments to any UPI ID, Contact or QR Code
            </h2>
            <p className="text-xl text-gray-600">Enjoy Super Quick Payments like Never Before!</p>
            
            <div className="bg-gradient-to-r from-blue-100 to-purple-100 rounded-3xl p-12 mt-12">
              <div className="relative">
                <Zap className="w-24 h-24 text-blue-600 mx-auto mb-6" />
                <div className="absolute -top-4 -right-4 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Journey Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Begin a seamless one-click payment journey
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "Get Started easily",
                desc: "With OmniCard you can utilize the power of UPI into your payment ecosystem like never before. Get smoother, Complete KYC and Onboard in Minutes",
                icon: <Star className="w-12 h-12 text-blue-600" />
              },
              {
                title: "Don't settle for Delays",
                desc: "Streamline your transactions with effortless UPI reconciliations and settlements. Enjoy a dependable payment journey with unparalleled convenience",
                icon: <Clock className="w-12 h-12 text-blue-600" />
              },
              {
                title: "Robust Security",
                desc: "OmniCard brings you Super Secure Payments, all without a bank account. OmniCard is your key to safe and easy transactions. Enjoy a stress-free spending experience with OmniCard",
                icon: <Shield className="w-12 h-12 text-blue-600" />
              }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="mb-6">{item.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-white mb-8">
                Turbocharge Your Business Payments with UPI
              </h2>
              <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8">
                <div className="text-center">
                  <CreditCard className="w-16 h-16 text-white mx-auto mb-4" />
                  <div className="text-2xl font-bold text-white">UPI</div>
                  <div className="text-blue-200 text-sm mt-2">Seamless Business Payments</div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Us</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Your Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="Enter Your Full Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    placeholder="Enter Your Phone Number"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Your Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Your Email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Company Name</label>
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    placeholder="Enter Your Company Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Your Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Enter Your Message"
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
                
                <button
                  onClick={handleSubmit}
                  className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 hover:shadow-lg transition-all transform hover:scale-105"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-5 gap-8">
            <div>
              <h3 className="font-semibold mb-4">How Can We Help?</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Phone: +91 22 3481 1400</li>
                <li>Email: contact@omnicard.com</li>
              </ul>
              <div className="mt-4">
                <h4 className="font-semibold mb-2">Business Hours</h4>
                <p className="text-sm text-gray-400">Monday - Friday<br/>9:00 AM - 6:00 PM</p>
              </div>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Find Us Here</h3>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">O</span>
                </div>
                <span className="font-bold">OmniCard</span>
              </div>
              <p className="text-sm text-gray-400 mb-4">
                Mumbai, Maharashtra, India<br/>
                Revolutionizing Business Payments
              </p>
              <div className="flex space-x-4">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                  <span className="text-white text-sm">f</span>
                </div>
                <div className="w-8 h-8 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer">
                  <span className="text-white text-sm">t</span>
                </div>
                <div className="w-8 h-8 bg-blue-700 rounded-full flex items-center justify-center hover:bg-blue-800 transition-colors cursor-pointer">
                  <span className="text-white text-sm">in</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Products</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors">UPI for Business</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Corporate Cards</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Expense Management</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Careers</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-sm text-gray-400 mb-4 md:mb-0">
                © 2025 OmniCard. All rights reserved.
              </div>
              <div className="flex space-x-6 text-sm text-gray-400">
                <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
                <a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}